import { render, staticRenderFns } from "./zorgverzekering.vue?vue&type=template&id=7c129552&"
import script from "./zorgverzekering.vue?vue&type=script&lang=js&"
export * from "./zorgverzekering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,InsuranceSearch: require('/home/nvpa/nvpa-corporate/nuxt/components/insurance/Search.vue').default,InsuranceTable: require('/home/nvpa/nvpa-corporate/nuxt/components/insurance/Table.vue').default})
